export const RELATIONSHIP = {
  FATHER: 1,
  MOTHER: 2,
  SON: 3,
  COUSIN: 4,
  UNCLE: 5,
  OTHER: 6
}